<template>
  <div class="d-flex justify-content-center queen-list">
    <b-container>
      <b-row>
        <b-col v-if="((!loaded && !showError) || deleteProgress)" class="col-12 col-md-12 mb-3">
          <b-card>
            <div class="d-flex justify-content-center mb-3 mt-3">
              <b-spinner></b-spinner>
            </div>
          </b-card>
        </b-col>
        <b-col v-if="showError" class="col-12 col-md-12 mb-3">
          <b-card>
            <p class="text-center">{{ $t('queens.error') }}</p>
          </b-card>
        </b-col>
        <b-col class="col-12 col-md-12 mb-3 position-relative">
          <b-link class="text-body" @click.prevent="clickNew" :title="$t('queen_create.title')">
            <b-card class="new h-100">
              <div class="h-100 d-flex flex-column justify-content-around">
                <h2 class="text-center mb-0">
                  {{ $t('queen_create.title') }}
                  <span class="icon-add_filled align-middle" aria-hidden="true"></span>
                </h2>
              </div>
            </b-card>
          </b-link>
        </b-col>
        <b-col class="col-12 col-md-12 mb-3 position-relative" v-for="(queen, i) in data" :key="i">
          <b-card>
<!--            <h2 class="text-body text-center ml-5 mr-5">{{ $t('queen.form.title.label') }}: {{ queen.title }}</h2>-->
            <h1 class="text-primary font-weight-bold text-center"> {{ queen.title }}</h1>
            <div class="text-center">
              {{ $t('queen.form.slipyear.label') }}: {{ queen.slipyear }}
            </div>
<!--            <div class="icon-crown_filled text-center" :style="{ color: queen.crownColor }"></div>-->
            <div class="text-center" :class="[(queen.crownColor ==='#fff') ? 'icon-crown' : 'icon-crown_filled']" :style="{ color: (queen.crownColor === '#fff')? '#D0D0D0' : queen.crownColor }"></div>
            <div class="action-row">
              <b-link class="text-body icon-pen" :title="$t('queen_edit.title')" @click.prevent="checkNetworkUpdate(queen.id)"></b-link>
            </div>
            <div class="action-row-delete">
              <queen-delete :id="queen.id" :colony="id" :apiary="apiary" :key="i" @confirmDelete="onClickDelete($event)"></queen-delete>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="confirmQueen" centered hide-header-close @ok="doDelete">
      <template slot="modal-title">
        {{ $t('queens.confirm_delete_before_new.title') }}
      </template>
      {{ $t('queens.confirm_delete_before_new.text') }}
      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button size="lg" class="ml-auto" @click="cancel()">
          {{ $t('queens.confirm_delete_before_new.no') }}
        </b-button>
        <b-button size="lg" class="mr-auto" @click="ok()">
          {{ $t('queens.confirm_delete_before_new.yes') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal :id="'offLineModalQueen'" centered hide-header-close @ok="hideModal" class="network-modal">
      <template slot="modal-title">
        {{ $t('offLineModal.title') }}
      </template>
      {{ $t('offLineModal.text') }}
      <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
        <b-button size="lg" class="mt-3" @click="ok()">
          {{ $t('offLineModal.ok') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import QueenDelete from '../components/ListQueenDelete'
export default {
  name: 'QueenList',
  props: ['id', 'apiary'],
  components: { QueenDelete },
  data () {
    return {
      showError: false,
      deleteProgress: false,
      loaded: false,
      data: null,
      deleteClicked: null
    }
  },
  // computed: {
  //   loaded () {
  //     return !!this.data
  //   }
  // },
  methods: {
    showOffLineModal () {
      this.$bvModal.show('offLineModalQueen')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalQueen')
    },
    checkNetworkUpdate (queenId) {
      if (navigator.onLine) {
        this.$router.replace('/queen/edit/' + queenId + '/' + this.id + '/' + this.apiary)
      } else {
        this.showOffLineModal()
      }
    },
    async loadData () {
      try {
        const colony = await this.$api.colonies.getOne(this.id)
        // console.log(colony)
        let queen
        if (colony.queen) {
          // console.log(colony.queen)
          queen = await this.$api.queens.getOne(colony.queen)
          // console.log(queen)
        }
        // console.log(queen)
        this.data = queen ? [queen] : []
        this.loaded = this.data
      } catch (e) { // network error etc.
        this.data = null
      }

      this.showError = !this.data
      return this.data
    },
    onClickDelete (value) {
      const vm = this
      if (value === 'Yes') {
        this.deleteProgress = true
        this.data = null
        setTimeout(function () {
          vm.deleteProgress = false
        }, 1000)
      }
    },
    clickNew () {
      if (navigator.onLine) {
        if (this.data.length > 0) {
          this.showModal()
        } else {
          this.$router.push('/queen/create/' + this.id + '/' + this.apiary)
        }
      } else {
        this.showOffLineModal()
      }
    },
    showModal () {
      this.$bvModal.show('confirmQueen')
    },
    async doDelete () {
      const token = await this.$api.user.getToken()
      const result = await this.$api.queens.deleteItem({ id: this.data[0].id, token })
      this.$router.push('/queen/create/' + this.id + '/' + this.apiary)
      return result
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  .queen-list {
    font-family: "Roboto Condensed", sans-serif;

    h2 {
      font-size: 1.5rem;
    }

    .action-row {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 1.5rem;
      line-height: 1rem;

      > * {
        display: inline-block;
        padding: 0.5rem 0.75rem;

        &:hover {
          text-decoration: none;
          background-color: $secondary-light;
        }
      }
    }

    .icon-crown_filled, .icon-crown {
      font-size: 2rem;
    }

    .new {
      background-color: $secondary-light;
    }
    .card-body {
      padding: 1.25rem;
    }
    .action-row-delete {
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 1.5rem;
      line-height: 1rem;

      > * {
        display: inline-block;
        padding: 0.5rem 0.75rem;

        &:hover {
          text-decoration: none;
          background-color: $secondary-light;
        }
      }
    }
    .card-body h1{
      font-size: 2rem;
      font-family: $font-family-base;
    }
  }
</style>
